import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import MainRoutes from "MainRoutes";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  HttpLink,
  split,
} from "@apollo/client";
import { getMainDefinition } from "@apollo/client/utilities";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";
import { ToastContainer, Flip } from "react-toastify";

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_SERVER_URL,
  headers: {
    authorization: localStorage.getItem("token"),
  },
});

const wsLink = new GraphQLWsLink(
  createClient({
    url: process.env.REACT_APP_WEBSOCKET_SERVER_URL,
    connectionParams: () => ({
      authToken: localStorage.getItem("token"),
    }),
  }),
);

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  httpLink,
);

const client = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache({}),
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ApolloProvider client={client}>
    <MainRoutes />
    <ToastContainer
      position="bottom-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      limit={2}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      transition={Flip}
    />
  </ApolloProvider>,
);

serviceWorker.unregister();
